/* eslint-disable react/prop-types */
// Copyright (c) 2019 Deere & Company

import './busy-counter-loading-indicator.scss';
import { LoadingIndicator } from './index';

import React from 'react';

const BusyCounterLoadingIndicator = ({ busyCounter }) => (
    busyCounter ? (
        <div className="full-page-loading-indicator">
            <LoadingIndicator />
        </div>
    ) : null
);

export default BusyCounterLoadingIndicator;
